import { Skeleton } from "@/components/ui/skeleton";
import { BuscarSorteioVigenteDto } from "@/dtos/BuscarSorteioVigenteDto";
import SorteioService from "@/services/SorteioService";
import { useEffect, useState } from "react";
import { ResultadosPage } from "../Resultados";
import { Separator } from "@/components/ui/separator";
import { NavLink } from "react-router-dom";
import { CompraRapida } from "@/components/CompraRapida";
import { HomeSorteioCarousel } from "@/components/HomeSorteioCarousel";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useLivePlayer } from "@/contexts/LivePlayerContext";

export function HomePage() {
    const { isOpen: livePlayerAberto, url: livePlayerUrl } = useLivePlayer();
    const [dadosSorteioVigente, setDadosSorteioVigente] = useState<BuscarSorteioVigenteDto>({} as BuscarSorteioVigenteDto);
    const [loading, setLoading] = useState(true)
    const [urlSorteioAoVivo, setUrlSorteioAoVivo] = useState<string>("");
    const [exibirModalAvisoSorteioAoVivo, setExibirModalAvisoSorteioAoVivo] = useState(false);

    function abrirMiniPlayerGlobal() {
        if (!urlSorteioAoVivo) {
            return;
        }

        window.dispatchEvent(new CustomEvent("live-player-open", { detail: { url: urlSorteioAoVivo } }));
    }

    useEffect(() => {
        async function buscarSorteioVigente() {
            setLoading(true)
            const result = await SorteioService.buscarSorteioVigente();
            setDadosSorteioVigente(result.Data);
            setLoading(false)
        }

        buscarSorteioVigente();
    }, [])

    useEffect(() => {
        const midiaTransmissaoAtiva = dadosSorteioVigente?.Midias?.find((midia) => midia.Ativo && midia.Tipo === 3);
        const idYoutube = midiaTransmissaoAtiva?.Url?.trim();

        if (!idYoutube) {
            setUrlSorteioAoVivo("");
            setExibirModalAvisoSorteioAoVivo(false);
            return;
        }

        const streamUrl = `https://www.youtube.com/watch?v=${idYoutube}`;
        setUrlSorteioAoVivo(streamUrl);
        const playerJaAbertoParaEsteStream = livePlayerAberto && livePlayerUrl === streamUrl;
        setExibirModalAvisoSorteioAoVivo(!playerJaAbertoParaEsteStream);
        // Só reage a Midias: fechar o player na mesma visita não reabre o aviso.
        // Ao voltar à Home, o efeito roda de novo e consulta o player vigente.
        // eslint-disable-next-line react-hooks/exhaustive-deps -- livePlayer só entra na decisão quando Midias mudam
    }, [dadosSorteioVigente?.Midias]);

    const sorteioGiro = dadosSorteioVigente?.SorteioGiro ?? null;

    return (
        <>
            <div className="mb-12">
                {
                    loading ? (
                        <div className="flex items-center">
                            <Skeleton className="h-80 bg-primary w-screen rounded-xl" />
                        </div>
                    ) : sorteioGiro ? (
                        <div className="flex flex-col">
                            <HomeSorteioCarousel
                                sorteioPrincipal={dadosSorteioVigente}
                                sorteioGiro={sorteioGiro}
                            />

                            {
                                urlSorteioAoVivo && (
                                    <div className="mx-5 mb-2 flex justify-center">
                                        <Button type="button" onClick={abrirMiniPlayerGlobal}>
                                            Assistir ao vivo
                                        </Button>
                                    </div>
                                )
                            }
                        </div>
                    ) : (
                        <div className="flex flex-col">
                            <div className="md:hidden m-5 flex flex-col justify-center items-center">
                                <img className="rounded-[5%]" src={dadosSorteioVigente.ImagemPremioApp} />
                            </div>

                            <div className="hidden m-5 md:flex flex-col justify-center items-center">
                                <NavLink to="/compra/titulos">
                                    <img className="rounded-lg" src={dadosSorteioVigente.ImagemPremio} />
                                </NavLink>
                            </div>

                            {
                                urlSorteioAoVivo && (
                                    <div className="mx-5 mb-2 flex justify-center">
                                        <Button type="button" onClick={abrirMiniPlayerGlobal}>
                                            Assistir ao vivo
                                        </Button>
                                    </div>
                                )
                            }

                            <CompraRapida />
                        </div>
                    )
                }

                <Separator className="mt-4" />
            </div>

            <h1 className="text-2xl justify-center text-center font-bold text-primary">Resultados</h1>

            <ResultadosPage exibirImagemSorteio={false} />

            <Dialog open={exibirModalAvisoSorteioAoVivo} onOpenChange={setExibirModalAvisoSorteioAoVivo}>
                <DialogContent className="w-[95vw] max-w-md">
                    <DialogHeader>
                        <DialogTitle>Sorteio ao vivo</DialogTitle>
                        <DialogDescription>
                            O sorteio ao vivo esta acontecendo agora. Deseja assistir?
                        </DialogDescription>
                    </DialogHeader>
                    <DialogFooter>
                        <Button type="button" variant="outline" onClick={() => setExibirModalAvisoSorteioAoVivo(false)}>
                            Fechar
                        </Button>
                        <Button type="button" onClick={() => {
                            abrirMiniPlayerGlobal();
                            setExibirModalAvisoSorteioAoVivo(false);
                        }}>
                            Ver o sorteio
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </>
    )
}
